import {Skeleton, Stack} from '@mui/material';

const CheckboxSkeleton = () => (
  <Stack direction="row" alignItems="center">
    <Skeleton
      animation="wave"
      variant="rounded"
      sx={{width: '16px', height: '16px', margin: '9px', marginLeft: '-4px'}}
    />
    <Skeleton animation="wave" variant="rounded" sx={{height: '24px', width: '50%'}} />
  </Stack>
);

export default CheckboxSkeleton;
